<template>
	<v-expansion-panel>
		<v-expansion-panel-title hide-actions readonly :color="color" style="cursor: default">
			<v-list-item class="traffic-log-event-container">
				<v-row no-gutters class="flex-nowrap" align="center">
					<v-col cols="3">
						<div class="text-body-2 px-1">
							{{ startTime }}
						</div>
					</v-col>
					<v-col cols="9">
						<div class="d-flex flex-column">
							<div class="text-caption text-truncate">
								{{ logEntry.displayName }}
							</div>
							<v-tooltip location="bottom" text="Advertiser name">
								<template v-slot:activator="{ props }">
									<div v-bind="props" class="text-truncate">
										{{ logEntry.advertiserName }}
									</div>
								</template>
							</v-tooltip>
						</div>
					</v-col>
				</v-row>
			</v-list-item>
		</v-expansion-panel-title>
	</v-expansion-panel>
</template>

<script>
/* Libraries */
import moment from "moment";

export default {
	name: "TrafficLogItem",

	props: ["selectedStation", "type", "logEntry", "spot"],

	computed: {
		startTime() {
			return moment.tz(this.logEntry.scheduledStartTime, this.selectedStation.StationTimeZone)
						 .format("HH:mm:ss");
		},

		darkMode() {
			return this.$store.getters.darkMode();
		},

		color() {
			if (this.darkMode) {
				return this.logEntry.blockNumber % 2 === 0 ? "#96979f" : null;
			}
			else {
				return this.logEntry.blockNumber % 2 === 0 ? "#a9afb2" : null;
			}
		}
	}
}
</script>

<style lang="scss" scoped>
:deep(.v-list-item.traffic-log-event-container) {
	border-left: 8px solid $ihm-grey;
	height: 48px;
	padding: 0;
	width: 100%;
}
</style>
